var React = require('react');

function ClearInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"12","cy":"12","r":"11","key":0}),React.createElement("path",{"d":"M16 8l-8 8m0-8l8 8","key":1})]));
}

ClearInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ClearInline;

ClearInline.default = ClearInline;
